export enum SignOffType {
    Directorate = 1,
    Project,
    PartnerOrganisation,
    Risk,
    FinancialRisk,
    Portfolio,
    Programme
}
